import { type IPaginationMetadata } from './generic.types';

export enum AuditCenterSearchByFormatedEnum {
  NAME = 'Name',
  PATIENT_USER_ID = 'Patient User Id',
  USER_ID = 'User Id',
}

export enum AuditCenterSearchByEnum {
  NAME = 'name',
  PATIENT_USER_ID = 'patientUserId',
  USER_ID = 'userId',
}

export interface IAuditLogsResponse {
  logs: ILog[] | null;
  metadata: IPaginationMetadata;
}

export interface ILog {
  category: string | LogCategoryEnum;
  details: string;
  patientEHRId: string;
  patientName: string;
  patientUserId: string;
  source: string;
  timestamp: string;
  type: string;
  userId: string;
  userName: string;
  value: string;
}

export enum LogCategoryEnum {
  ACTIVITY = 'Activity',
  BLOOD_GLUCOSE = 'BLOOD_GLUCOSE',
  BLOOD_PRESSURE = 'BLOOD_PRESSURE',
  CGM = 'CGM',
  CHATBOT = 'CHATBOT',
  INSULIN = 'INSULIN',
  MEDICATION = 'MEDICATION',
  PATIENT = 'PATIENT',
  PROVIDER = 'PROVIDER',
  RESTING_HEART_RATE = 'RESTING_HEART_RATE',
  SETTINGS = 'SETTINGS',
  SYMPTOM = 'SYMPTOM',
  WEIGHT = 'WEIGHT',
}
